<template>
  <component :is="iconComponent" class="drawing-tools-icon"></component>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { isDefined } from "@utils/var.check";
import { defineAsyncComponent, markRaw } from "vue";

interface Props {
  name?: string;
}

const props = withDefaults(defineProps<Props>(), {
  name: undefined,
});

const iconComponent = computed(() => {
  if (isDefined(props.name)) {
    return markRaw(
      defineAsyncComponent(
        () => import(`../../../assets/images/drawing/${props.name}.svg?component`),
      ),
    );
  }
  return "";
});
</script>

<style lang="scss">
.drawing-tools-icon {
  g {
    clip-path: none;
  }
}
</style>
